<app-fixed-editor *ngIf="_element.editorId && fixedEditor && !isSubmitted" [element]="fixedEditor"></app-fixed-editor>
<div *ngIf="!isSubmitted && !immediateFeedBackRequired" [attr.id]="'destination'+index"
  class="new-question new-question-top-align mx-auto" [class.fullheight-scroll-container]="!isSubmitted">
  <div class="new-question__container next-button-spacing">
    <div class="new-question--titleBox">
      <div [froalaView]="_element?.question" class="mg-b10 font-16 lh-30 font-mob-14 lh-mob-24"></div>
    </div>
    <div class="new-options">
      <div class="rating-select2">
        <label *ngFor="let opt of _element.options" class="rating-select2__option">
          <span class="rating-select2__radiotext">
            <input class="rating-select2__radio" [value]="opt._id" type="radio" [(ngModel)]="radioSelected"
              [name]="_element._id">
            <span class="rating-select2__icon-radio"></span>
            <span class="rating-select2__title">{{opt.text}}</span>
          </span>
        </label>
      </div>
    </div>
    <app-exercise-navigation-bar [id]="id" [id]="id" class="rating--button" [questionAttempted]="radioSelected" (onNext)="next(radioSelected)"
      (onSubmit)="next(radioSelected,true)"
      [exerciseTimetrackingdata] ="exerciseTimetrackingdata"
      [index]='index'
      >
    </app-exercise-navigation-bar>
  </div>
</div>
<div *ngIf="!isSubmitted && immediateFeedBackRequired" [attr.id]="'destination'+index"
  class="new-question new-question-top-align mx-auto" [class.fullheight-scroll-container]="!isSubmitted">
  <div class="new-question__container next-button-spacing">
    <div class="new-question--titleBox">
      <div [froalaView]="_element?.question" class="mg-b10 font-16 lh-30 font-mob-14 lh-mob-24"></div>
    </div>
    <div class="new-options">
      <div class="rating-select2">
        <label *ngFor="let opt of _element.options" [class.disabled]="questionChecked" class="rating-select2__option">
          <span class="rating-select2__radiotext">
            <input class="rating-select2__radio" [value]="opt._id" type="radio" [(ngModel)]="radioSelected"
              [name]="_element._id">
            <span class="rating-select2__icon-radio"></span>
            <span class="rating-select2__title">{{opt.text}}</span>
          </span>
        </label>
      </div>
    </div>
    <div *ngIf="radioSelected && questionChecked &&  _element?.isFeedbackEnabled" class="overall-feedback pb-0">
      <p [froalaView]="_element.feedback" class="overall-feedback__desc"></p>
    </div>
    <app-exercise-navigation-bar [id]="id" [immediateFeedBackRequired]="true" [questionAttempted]="radioSelected"
      (onReview)="check()" (onNext)="next(radioSelected)" (onSubmit)="next(radioSelected,true)"
      [questionChecked]="questionChecked"
      [exerciseTimetrackingdata] ="exerciseTimetrackingdata"
      [index]='index'
      >
    </app-exercise-navigation-bar>
  </div>
</div>
<div *ngIf="isSubmitted" [attr.id]="'destination'+index" [class.new-options--not-answered]="!_answer"
  class="new-question new-question-top-align mx-auto" [class.fullheight-scroll-container]="!isSubmitted">
  <div class="new-question__container">
    <div class="new-question--titleBox"
      [class.score-applied]="_element?.isScoring &&  _answer && points  && isResultPublished">
      <div [froalaView]="_element?.question" class="mg-b10 font-16 lh-30 font-mob-14 lh-mob-24"></div>
      <!-- <span *ngIf="!isPractice && _element?.isScoring &&  _answer && points  && isResultPublished && !isTouchstone"
        class="answer-point">Points:
        {{(points?points.point:0 ) | number:'1.0-2'}} out of
        {{(points?points.total:0 ) | number:'1.0-2'}}</span> -->
    </div>
    <div class="new-options">
      <div class="rating-select2 py-2">
        <label *ngFor="let opt of _element.options" class="rating-select2__option disabled">
          <span class="rating-select2__radiotext">
            <input class="rating-select2__radio" [value]="opt._id" type="radio" [ngModel]="radioSelected"
              [name]="_element._id">
            <span class="rating-select2__icon-radio"></span>
            <span class="rating-select2__title">{{opt.text}}</span>
          </span>
        </label>
      </div>
    </div>
     <!-- thrive -->
     <ng-container *ngIf="questionBlos && questionBlos.length">     
      <h5 class="question__thrive">Thrive Skills:</h5>
      <div class="question__thrive-list">
        <ul>
          <ng-container *ngFor="let blo of questionBlos">
            <li [innerHTML]="blo.shortStatement"></li>
          </ng-container>
        </ul>
      </div>
    </ng-container>
    <div *ngIf="_element?.isFeedbackEnabled" class="overall-feedback">
      <p [froalaView]="_element.feedback" class="overall-feedback__desc"></p>
    </div>
  </div>
  <!-- <app-like-dislike [id]="id" *ngIf="_element?.isFeedbackEnabled" [userFeedback]="userFeedback" [_element]="_element"
    (reportFeedback)="_reportFeedback($event)" (likeDislike)="_likeDislike($event)">
  </app-like-dislike> -->
</div>
